// extracted by mini-css-extract-plugin
export var border = "_17-7";
export var brand = "_17-s";
export var button = "_17-k";
export var center = "_17-9";
export var centered = "_17-5";
export var closeButton = "_17-b";
export var disabledWrapper = "_17-l";
export var error = "_17-o";
export var extraLarge = "_17-4";
export var extraSmall = "_17-1";
export var fill = "_17-h";
export var footer = "_17-g";
export var footerAction = "_17-i";
export var footerButtons = "_17-j";
export var header = "_17-6";
export var headerWithClose = "_17-c";
export var icon = "_17-n";
export var info = "_17-r";
export var inline = "_17-8";
export var large = "_17-3";
export var main = "_17-d";
export var modal = "_17-0";
export var neutral = "_17-t";
export var noPadding = "_17-f";
export var none = "_17-u";
export var scrollable = "_17-e";
export var small = "_17-2";
export var success = "_17-q";
export var tight = "_17-m";
export var titleIcon = "_17-a";
export var warn = "_17-p";